import {Box, Flex, P} from 'exsportia-components'
import React, {FC, PropsWithChildren} from 'react'

import {RadioButton} from './index'

export type Value<X = Record<string, unknown> | number | string | null> = X

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ItemProps<X = any> = PropsWithChildren<Option<X>>

export type Option<X = Value> = {
  select: (value: X) => void
  value: X
  selected: boolean
  disabled: boolean
  label?: string
  labelComponent?: FC<ItemProps>
  itemComponent?: FC<ItemProps>
}

type Props = {
  options: Option[]
  itemComponent?: FC<ItemProps>
  labelComponent?: FC<ItemProps>
}

const DefaultLabelComponent: FC<ItemProps> = ({children}) => (<P>{children}</P>)

const DefaultOptionComponent: FC<ItemProps> = ({children}) => (
  <Flex
    flexDirection={'row'}
  >
    <Box>
      {children}
    </Box>
  </Flex>
)

export const RadioButtonOptionsList: FC<Props> = ({
  options,
  itemComponent: TopLevelItemComponent,
  labelComponent: TopLevelLabelComponent
}) => (
  <Flex flexDirection='column' gap='16px'>
    {
      options.map((props) => {
        const {
          value,
          select,
          selected,
          disabled,
          label,
          itemComponent: SpecifiedOptionItemComponent,
          labelComponent: SpecifiedOptionLabelComponent,
        } = props
        const OptionItemComponent =
          SpecifiedOptionItemComponent
          || TopLevelItemComponent
          || DefaultOptionComponent
        const LabelComponent = SpecifiedOptionLabelComponent
          || TopLevelLabelComponent
          || DefaultLabelComponent
        return (
          <OptionItemComponent
            {...props}
          >
            <Flex
              flexDirection={'row'}
            >
              <RadioButton
                disabled={disabled}
                checked={selected}
                onChange={() => select(value)}
              />
              <LabelComponent {...props}>
                {label}
              </LabelComponent>
            </Flex>
          </OptionItemComponent>
        )
      })
    }
  </Flex>
)
